// @need-translate
import {UrlLink} from '../../../applink/UrlLink';
import {t} from '../../../common/getTranslations';
import {PolicyType} from '../../../common/shared/utils/PolicyType.enum';
import {twMerge} from '../../../common/twMerge';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {Text} from '../../atoms/Text/Text';

export function SelectTermsType({termsType}: {termsType: PolicyType}) {
  return (
    <div className="mt-32pxr! flex">
      <UrlLink url="/policy/terms" linkClassName="no-underline!">
        <Text
          className={twMerge(
            'font-large4-bold!',
            termsType === PolicyType.TermsPaid && 'text-theme-solid-20'
          )}
        >
          {t('more_customer_terms_use')}
        </Text>
      </UrlLink>
      <Divider
        color={theme.colors['theme-transparent-10']}
        direction="vertical"
        className="my-0! mx-12pxr"
      />
      <UrlLink url="/policy/terms-paid" linkClassName="no-underline!">
        <Text
          className={twMerge(
            'font-large4-bold!',
            termsType === PolicyType.Terms && 'text-theme-solid-20'
          )}
        >
          유료서비스이용약관
        </Text>
      </UrlLink>
    </div>
  );
}
